import { TSearchOptions } from "../redux/models"
import axios from "axios"
import { call, put } from "redux-saga/effects"
import { ISearchAction } from "../actions/search"
import { getToken } from "../authentication"

const delay = (ms: number) => new Promise(response => setTimeout(response, ms))

export type Store_SearchOptions = {
    type: "STORE_SEARCH_OPTIONS",
    payload: {
        searchOptions: TSearchOptions[]
    }
}

export type TAlertsTrendData = {
    searchOptions: TSearchOptions[]
}

export function* getSearchOptions(params: ISearchAction) {
    try {
        const data: TSearchOptions[] = yield call(fetchSearchOptions, params)
        yield put({
            type: "STORE_SEARCH_OPTIONS",
            payload: {
                searchOptions: data
            }
        } as Store_SearchOptions)
    } catch (error) {
        console.log("get search options error", error)
    }
}

async function fetchSearchOptions(params: ISearchAction) {
    let response = [];
    response = await SearchOptions(params)
    const data: TSearchOptions[] = response
    return data
}

async function SearchOptions(params: any) {
    const tokenRes = await getToken();
    const response = await axios.get(
        process.env.REACT_APP_WEBAPPAPI + "/alertdashboardsearch?searchKey=" + params.payload.frameId+"&org_id="+params.payload.org_id,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: tokenRes.token!,
          },
        }
      );
    return response.data.data as any
}